import { SPSDrive } from './appConstants';

// SharePoint site id for the different environment
const sharePointSiteId = {
  streamrealty: {
    dev: 'b9d2daba-1e44-4b4e-a70e-c580267dd6de,a1d329a1-aa82-41ad-95b5-03844c955175',
    test: 'b9d2daba-1e44-4b4e-a70e-c580267dd6de,a1d329a1-aa82-41ad-95b5-03844c955175',
    // test: '811357dc-34fe-4c7f-ad8f-bc9cf6a8e067,a1d329a1-aa82-41ad-95b5-03844c955175',
    stage: '9ef7c438-6e40-4ecf-ae1d-b010297aab02,a1d329a1-aa82-41ad-95b5-03844c955175',
    prod: 'ab048aef-43e9-4c53-91eb-93a9cb0d0c6a,7aba83d0-2411-4150-8e6d-a2116d9d0100'
  }
};

// Get site id based on current environment
function getCurrentEnvironmentSiteId(tenant = 'streamrealty') {
  if (window.location.href.indexOf('132.196.116.77:8080/') > 0 || window.location.href.indexOf('4.151.136.111:8080') > 0) {
    return sharePointSiteId[tenant].test;
  } else if (window.location.href.indexOf('23.101.122.140:8080') > 0 || window.location.href.indexOf('20.97.26.254') > 0) {
    return sharePointSiteId[tenant].stage;
  } else if (window.location.href.indexOf('allocations.streamrealty.com') > 0) {
    return sharePointSiteId[tenant].prod;
  } else if (window.location.href.indexOf('20.189.16.43:8080') > 0 || window.location.href.indexOf('52.141.90.157') > 0) {
    return sharePointSiteId[tenant].prod;
  }
  return sharePointSiteId[tenant].test;
}
// Get current environment based on url
export function getCurrentEnvironment(tenant = 'streamrealty') {
  if (window.location.href.indexOf('132.196.116.77:8080/') > 0 || window.location.href.indexOf('4.151.136.111:8080') > 0) {
    return 'test';
  } else if (window.location.href.indexOf('23.101.122.140:8080') > 0 || window.location.href.indexOf('20.97.26.254') > 0) {
    return 'stage';
  } else if (window.location.href.indexOf('localhost') > 0) {
    return 'test';
  } else if (window.location.href.indexOf('allocations.streamrealty.com') > 0) {
    return 'prod';
  } else if (window.location.href.indexOf('20.189.16.43:8080') > 0 || window.location.href.indexOf('52.141.90.157') > 0) {
    return 'prod';
  }

  return 'test';
}

// Get SharePoint url
export function getSharePointUrl(
  domain,
  name = 'getSps',
  Key,
  fileName = '',
  driveId,
  FileId
) {
  if (getCurrentEnvironment() === 'prod') {
    switch (name) {
      case 'createFolder':
        // return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/drive/root/children`;
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives/b!74oEq-lDU0yR65Opyw0MatCDunoRJFBBjm2iEW2dAQDbbt1uUi96T6HKBRZKQ_VP/root/children`;
      case 'getFolder':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives/b!74oEq-lDU0yR65Opyw0MatCDunoRJFBBjm2iEW2dAQDbbt1uUi96T6HKBRZKQ_VP/root:/` + fileName;
      // case "getInnerFolder":
      //   return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
      //     domain
      //   )}/lists/${Key}/drive/items/${getFolderId(domain, fileName)}/children`;
      case 'getChildItem':
        // return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/drives/${driveId}/items/${Key}/children?expand=listItem($expand=fields)`;
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives/b!74oEq-lDU0yR65Opyw0MatCDunoRJFBBjm2iEW2dAQDbbt1uUi96T6HKBRZKQ_VP/items/${Key}/children?expand=listItem($expand=fields)`;
      case 'uploadNew':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives/${driveId}/items/${Key}/children`;
      case 'createLink':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/${Key}/drive/items/${FileId}/createLink`;
      case 'getSps':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/6edd6edb-2f52-4f7a-a1ca-05164a43f54f/drive/root:/${fileName}:/children?expand=listItem($expand=fields)`;
      case 'createDrive':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists`;
      case 'uploadFile':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/${Key}/drive/root:/${fileName}:/content?expand=listItem($expand=fields)`;

      case 'uploadMetadata':
        // Here fileName is a itemId
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/6edd6edb-2f52-4f7a-a1ca-05164a43f54f/items/${fileName}/fields`;

      case 'uploadFileSession':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/6edd6edb-2f52-4f7a-a1ca-05164a43f54f/drive/root:/${driveId}/${fileName}:/createUploadSession`;
      case 'deleteFile':
        // Here fileName is a itemId
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/6edd6edb-2f52-4f7a-a1ca-05164a43f54f/items/${fileName}`;
      case 'getDriveList':
        // Here fileName is a itemId
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives`;
      // case "deleteFileByDrive":
      //   return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
      //     domain
      //   )}/drives/${getDriveId(Key)}/root:/${fileName}`;
      case 'deleteFileByDrive':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/6edd6edb-2f52-4f7a-a1ca-05164a43f54f/drive/root:/${driveId}/${fileName}`;
      case 'aboutUsDetails':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/About/Items?expand=listItem($expand=fields)`;
    }
  } 
  else if (getCurrentEnvironment() === 'stage') {
    switch (name) {
      case 'createFolder':
        // return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/drive/root/children`;
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives/b!OMT3nkBuz06uHbAQKXqrAqEp06GCqq1BlbUDhEyVUXV4rYDbDbDeR7299U8eQvBi/root/children`;
      case 'getFolder':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives/b!OMT3nkBuz06uHbAQKXqrAqEp06GCqq1BlbUDhEyVUXV4rYDbDbDeR7299U8eQvBi/root:/` + fileName;
      // case "getInnerFolder":
      //   return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
      //     domain
      //   )}/lists/${Key}/drive/items/${getFolderId(domain, fileName)}/children`;
      case 'getChildItem':
        // return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/drives/${driveId}/items/${Key}/children?expand=listItem($expand=fields)`;
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives/b!OMT3nkBuz06uHbAQKXqrAqEp06GCqq1BlbUDhEyVUXV4rYDbDbDeR7299U8eQvBi/items/${Key}/children?expand=listItem($expand=fields)`;
      case 'uploadNew':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives/${driveId}/items/${Key}/children`;
      case 'createLink':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/${Key}/drive/items/${FileId}/createLink`;
      case 'getSps':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/db80ad78-b00d-47de-bdbd-f54f1e42f062/drive/root:/${fileName}:/children?expand=listItem($expand=fields)`;
      case 'createDrive':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists`;
      case 'uploadFile':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/${Key}/drive/root:/${fileName}:/content?expand=listItem($expand=fields)`;

      case 'uploadMetadata':
        // Here fileName is a itemId
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/db80ad78-b00d-47de-bdbd-f54f1e42f062/items/${fileName}/fields`;

      case 'uploadFileSession':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/db80ad78-b00d-47de-bdbd-f54f1e42f062/drive/root:/${driveId}/${fileName}:/createUploadSession`;
      case 'deleteFile':
        // Here fileName is a itemId
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/db80ad78-b00d-47de-bdbd-f54f1e42f062/items/${fileName}`;
      case 'getDriveList':
        // Here fileName is a itemId
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/drives`;
      // case "deleteFileByDrive":
      //   return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
      //     domain
      //   )}/drives/${getDriveId(Key)}/root:/${fileName}`;
      case 'deleteFileByDrive':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/db80ad78-b00d-47de-bdbd-f54f1e42f062/drive/root:/${driveId}/${fileName}`;
      case 'aboutUsDetails':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(
          domain
        )}/lists/About/Items?expand=listItem($expand=fields)`;
    }
  } else {
    switch (name) {
      case 'createFolder':
        // return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/drive/root/children`;
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists`;
      case 'getFolder':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/${fileName}`;
      case 'getChildItem':
        // return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/drives/${driveId}/items/${Key}/children?expand=listItem($expand=fields)`;
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/${Key}/drive/root/children?expand=listItem($expand=fields)`;
      case 'uploadNew':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/drives/${driveId}/items/${Key}/children`;
      case 'createLink':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/${Key}/drive/items/${FileId}/createLink`;
      case 'getSps':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/${Key}/drive/root/children?expand=listItem($expand=fields)`;
      case 'createDrive':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists`;
      case 'uploadFile':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/${Key}/drive/root:/${fileName}:/content?expand=listItem($expand=fields)`;

      case 'uploadMetadata':
        // Here fileName is a itemId
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/${Key}/items/${fileName}/fields`;

      case 'uploadFileSession':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/${Key}/drive/root:/${fileName}:/createUploadSession`;
      case 'deleteFile':
        // Here fileName is a itemId
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/${Key}/items/${fileName}`;
      case 'getDriveList':
        // Here fileName is a itemId
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/drives`;
      case 'deleteFileByDrive':
        // return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/drives/${getDriveId(Key)}/root:/${fileName}`;
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/${Key}/drive/root:/${fileName}`;
      case 'aboutUsDetails':
        return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId(domain)}/lists/About/Items?expand=listItem($expand=fields)`;
    }
  }
}

// Get SharePoint drive Id based on the key
function getDriveId(Key) {
  try {
    if (SPSDrive && SPSDrive.value) {
      return SPSDrive.value.filter(data => {
        return data.name === Key;
      })[0].id;
    }
  } catch (e) { }
}
